import * as Distance from "~/Distance";
import * as Log from "~/Log";
import { Time } from "~/Time";

export type Count = Distance.Distance &
  Time.Duration & { readonly assets: number };

export const empty = (): Count => ({
  distance: { miles: 0 },
  assets: 0,
  duration: 0,
});

export const use = (): Count => {
  const interval = Log.Unassigned.Route.useRouteInterval();
  return Log.Unassigned.Count.toCount(Log.Unassigned.useOrEmpty(interval));
};

export const toCount = ({ logs }: Log.Unassigned.UnassignedLogs): Count => {
  return logs.reduce<{
    readonly assetIDs: readonly string[];
    readonly counts: Count;
  }>(
    (p, c) => {
      return {
        assetIDs: [...p.assetIDs, c.asset.id],
        counts: {
          distance: { miles: p.counts.distance.miles + c.distance.miles },
          duration:
            p.counts.duration +
            Time.Interval.Stopped.toDuration(
              Time.Interval.isStopped(c)
                ? c
                : Time.Interval.Started.toStopped(Time.DateTime.now())(c)
            ).duration,

          assets: p.assetIDs.includes(c.asset.id)
            ? p.counts.assets
            : p.counts.assets + 1,
        },
      };
    },
    {
      assetIDs: [],
      counts: empty(),
    }
  ).counts;
};
